module.exports = __webpack_public_path__ + "img/362f40b.jpg";